import { API, Auth } from "aws-amplify";

const gatewayId = "OmniAPI";

export const awsVerifyEmbeds = async payload => {
  const session = await Auth.currentSession();
  const token = session.getIdToken().getJwtToken();

  return API.post(gatewayId, "embeds/verify", {
    headers: { authorization: `Bearer ${token}` },
    body: payload,
  });
};

export const awsPublishEmbeds = async payload => {
  const session = await Auth.currentSession();
  const token = session.getIdToken().getJwtToken();

  return API.post(gatewayId, "embeds/publish", {
    headers: { authorization: `Bearer ${token}` },
    body: payload,
  });
};

export const awsRestoreEmbedBackup = async payload => {
  const session = await Auth.currentSession();
  const token = session.getIdToken().getJwtToken();

  return API.post(gatewayId, "embeds/restore", {
    headers: { authorization: `Bearer ${token}` },
    body: payload,
  });
};
